import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'raqt-schedule-print-list-prefs';

type StoredPrefs = {
  listCategoryIds?: number[] | null;
};

const readStoredPrefs = (): StoredPrefs => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as StoredPrefs;
  } catch {
    return {};
  }
};

export function useSchedulePrintListPrefs() {
  const [listCategoryIds, setListCategoryIds] = useState<number[] | null>(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const stored = readStoredPrefs();
    if (stored.listCategoryIds !== undefined) setListCategoryIds(stored.listCategoryIds);
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    const payload: StoredPrefs = { listCategoryIds };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  }, [hydrated, listCategoryIds]);

  const resetListPrefs = useCallback(() => {
    setListCategoryIds(null);
  }, []);

  return {
    listCategoryIds,
    setListCategoryIds,
    resetListPrefs,
  };
}
